<h1 mat-dialog-title class="title">Failure to Submit Form</h1>
<div mat-dialog-content class="image-text">
  <img
    src="../../../../assets/weDraw-Images/undraw_warning_re_eoyh.svg"
    alt="orange shirt man with a warning sign"
    width="200"
    height="200"
  />
  <p>
    Please reach out to
    <a href="mailto:mobilecredentials@allegion.com"
      >mobilecredentials&#64;allegion.com</a
    >
    to make sure your account is tied to a company.
  </p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true">OK</button>
</div>
